import React from 'react'

export const useStateWithCallback = initialState => {
  const [state, setState] = React.useState(initialState)
  const callbackRef = React.useRef()

  const handleSetState = (updatedState, callback = null) => {
    callbackRef.current = callback
    setState(updatedState)
  }

  React.useEffect(() => {
    if (typeof callbackRef.current === 'function') {
      callbackRef.current(state)
      callbackRef.current = undefined
    }
  }, [state])

  return [state, handleSetState]
}

export default useStateWithCallback
